{
  "fr": {
    "snippets": {
      "labels": {
        "cancel": "Annuler",
        "confirm": "Confirmer",
        "create": "Créer un extrait",
        "delete": "Supprimer",
        "edit": "Modifier",
        "editTitle": "Modifier l'extrait",
        "initMessage": "Sélectionnez un extrait pour le prévisualiser ici.",
        "language": "Langue",
        "linkable": "Taper",
        "linkableClient": "Équipe",
        "linkableEmployee": "Personnel",
        "linkablePartner": "Partenaire",
        "manage": "Gérez vos extraits",
        "manageMessage": "Ou cliquez ici pour gérer tous vos extraits de code dans les paramètres de l'entreprise",
        "message": "Message",
        "messageError": "Veuillez saisir un message",
        "new": "Nouvel extrait",
        "noSnippets": "Vous n'avez pas encore d'extraits.",
        "preview": "Aperçu",
        "save": "Sauvegarder",
        "search": "Recherche",
        "select": "Sélectionner",
        "snippets": "Extraits",
        "title": "Titre",
        "titleError": "Veuillez saisir un titre"
      }
    }
  }
}